/*
 * @Author: 智客云网络科技
 * @Date: 2022-02-06 17:57:55
 * @LastEditors: 阡陌OvO
 * @LastEditTime: 2022-04-24 14:57:33
 * @Description: 状态管理
 * @FilePath: \src\store\index.js
 */
import { createStore } from "vuex";
import actions from "./actions";
import mutations from "./mutations";
import UserModule from "./UserModule";
import RouterModule from "./RouterModule";
import MenuModule from "./MenuModule";
import WebModule from "./WebModule";

const state = {
  version: process.env.VUE_APP_APP_VERSION, //系统版本
  title: process.env.VUE_APP_APP_TITEL, //标题
  title_prefix: process.env.VUE_APP_TITEL_PREFIX, //标题前缀
  themeV: process.env.VUE_APP_THEME_V, //默认主题
  themeToggling: false, //主题是否正在切换
  systemInit: false, //系统初始化状态
  cashViews: [], //已打开的页面名称 缓存页面用
  themeList: [
    { name: "白色", value: "1", show_all: false },
    { name: "暗色", value: "2", show_all: false },
  ], //可用主题列表
};

const store = createStore({
  //全局状态
  state,
  mutations,
  actions,
  //模块
  modules: {
    UserModule,
    RouterModule,
    MenuModule,
    WebModule,
  },
});

//将store store 导出去
export function myStore() {
  return store;
}

//导出
export default store;
